export default "__VITE_ASSET__DKYSnzWv__"